export default "__VITE_ASSET__CNeYreR8__"